import { Card, CardContent, Typography } from '@mui/material';
import { DashboardOutlined } from '@mui/icons-material';
import { NavLink, useLocation } from 'react-router';
import { useTranslations } from '@/i18n/use-translations';

interface DashboardButtonProps {
  onClick?: () => void;
}

export default function DashboardButton({ onClick }: DashboardButtonProps) {
  const t = useTranslations();
  const location = useLocation();
  const isDashboardSelected = location.pathname === '/contributions' || location.pathname.startsWith('/contributions/');

  return (
    <NavLink
      to="/contributions"
      onClick={onClick}
      style={{
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Card
        sx={{
          'width': 250,
          'boxShadow': 'none',
          'border': `1px solid`,
          'borderColor': 'divider',
          'borderRadius': 2,
          'cursor': 'pointer',
          'transition': 'all 0.2s ease',
          '&:hover': {
            boxShadow: 2,
            borderColor: 'primary.main',
          },
          ...(isDashboardSelected && {
            borderColor: 'primary.main',
            backgroundColor: 'background.paper',
          }),
        }}
      >
        <CardContent
          sx={{
            'display': 'flex',
            'alignItems': 'center',
            'gap': 1,
            'py': 1.5,
            'px': 2,
            '&.MuiCardContent-root': {
              paddingBottom: '12px',
            },
          }}
        >
          <DashboardOutlined
            sx={{
              fontSize: '1.0rem',
              color: isDashboardSelected ? 'primary.main' : 'inherit',
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              color: isDashboardSelected ? 'primary.main' : 'inherit',
              fontWeight: isDashboardSelected ? 500 : 400,
            }}
          >
            {t('common.dashboard')}
          </Typography>
        </CardContent>
      </Card>
    </NavLink>
  );
}
